<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-350 o-dialog--xl-250"
    title="上传消防数字平台"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="220px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col"
          :span="24"
        >
          <div style="margin: 15px 20px;">
            <div style="font-size: 18px;font-weight: bold;">
              是否确认将报告推送消防数字平台？
            </div>
            <div style="margin-top: 10px;font-size: 16px;font-weight: bold;">
              注意：
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              1、已推送成功的报告不能重复上传报告；
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              2、推送的报告以最新上传的报告为准；
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              3、上传报告必须是电子报告（电子公章）或原件扫描件（公司印章及签名）；
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              4、报告推送成功后不能修改报告信息；
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              5、消防数字平台为响应国家数字消防赋能号召，为消防行业提供数字化服务的平台，为消防行业提供数字化服务，提升消防行业的数字化水平；
            </div>
            <div style="margin-top: 5px;font-size: 14px;">
              6、消防数字平台请访问:<a
                href="https://iff-rpa.hongmeng.cloud"
                target="_blank"
                style="color: blue; text-decoration: underline;"
              >鸿蒙消防数字平台；</a>
            </div>
          </div>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="联网单位"
            prop="ssdw"
          >
            <el-select
              v-model="fd.ssdw"
              placeholder="请选择消防数字平台单位"
            >
              <el-option
                v-for="item in lwdws"
                :key="item.ssdw"
                :label="item.dwMc"
                :value="item.ssdw"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <div style="margin-top: 10px;margin-left: 10px;">
            <span style="color: red; font-size: 12px;">如不存在可选择的消防数字平台单位，</span>
            <span style="color: red; font-size: 12px;">请联系管理人员确认双方统一社会信用代码是否匹配</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="推送"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { bgglService } from './bggl.service';
export default {
  name: 'SzptDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading
      lwdws: [], // 联网单位
      dialogShow: true, // 模态框dialog显示
      bgId: '',
      fd: {
        bgId: null,
        byry: null,
        byrq: null,
        wbjl: null,
        ssdw: null // 新增字段，用于绑定下拉菜单的值
      },
      fdRules: {
        // byry: [this.$validUtils.required('保养人员')],
        // byrq: [this.$validUtils.required('保养日期')],
        ssdw: [this.$validUtils.required('联网单位')]
      }
    };
  },
  methods: {
    /**
     * @description: 获取联网单位
     */
    queryLwdws () {
      const _this = this;
      _this.loading = true;
      bgglService.lwdwptLsdws(_this.bgId)
        .then(rsp => {
          this.lwdws = rsp.data;
          if (this.lwdws.length === 1) {
            this.fd.ssdw = this.lwdws[0].ssdw;
          }
          console.log('联网单位', this.lwdws);
        })
        .catch(err => {
          console.error('查询错误！', err);
        }).finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          const params = {
            bgId: _this.bgId,
            byry: _this.fd.byry,
            byrq: _this.fd.byrq,
            wbjl: _this.fd.wbjl,
            ssdw: _this.fd.ssdw
          };
          bgglService.lwdwptSjTb(params)
            .then(rsp => {
              _this.$alert('上传成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('上传错误！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.bgId = this.dlParams.bgId;
    this.fd.bgId = this.dlParams.bgId;
    this.queryLwdws();
  }
};
</script>
<style scoped>
/* 覆盖 Element UI 组件的 :before 样式 */
.c-form__col.c-form__part-title::before {
  content: none !important;
}
.block {
  display: block;
  margin-bottom: 10px; /* 可选：添加一些底部间距 */
}
</style>
